/**
 * Utility functions for ProductOverviewRightRailLinks
 */
import { downloadDocument } from '@/modules/products/ProductOverviewPage/services/downloadDocument.service'
import { useRouter } from 'next/router'

/**
 * Processes a document path for download by removing the leading slash, adjusting the path if needed, and calling downloadDocument.
 * @param path The original document path
 * @param title The document title
 * @param cookies The cookies array containing locale
 * @returns Promise<void>
 */
export async function handleDocumentDownload(
  path: string,
  title: string,
  cookies: { locale: string }[]
): Promise<void> {
  const DOCUMENT_PATH_WITHOUT_SLASH = path.replace('/', '')
  const DOCUMENT_PATH = DOCUMENT_PATH_WITHOUT_SLASH
  const docPath = DOCUMENT_PATH.split('/')
  if (docPath.length === 5) {
    docPath.splice(1, 1) // Remove the element at index 1
  }
  const resultPath = docPath.join('/')
  await downloadDocument(resultPath, title, cookies[0].locale)
}

/**
 * Redirects the user to the login page with a callback URL to return after login.
 * @param router The Next.js router instance
 * @returns void
 */
export function redirectToLogin(router: ReturnType<typeof useRouter>): void {
  router.push({
    pathname: '/login',
    query: {
      callbackUrl: router.asPath,
    },
  })
}

/**
 * Handles click event for login redirect, including Postman download tracking.
 * @param event The click event from the anchor element
 * @param router The Next.js router instance
 * @returns void
 */
export function handleLoginRedirectClick(
  event: React.MouseEvent<HTMLAnchorElement>,
  router: ReturnType<typeof useRouter>
): void {
  if (event.currentTarget.innerText.toLowerCase().includes('postman')) {
    localStorage.setItem('postmanDownloadRequested', 'true')
  }
  redirectToLogin(router)
}
